<template>
  <div class="xiaohs-card-content">
    <div class="card-category-badge">{{ cardItem.card_category_name || "卡片" }}</div>
    <div class="avatar-wrap">
      <img v-if="cardItem.image" :src="cardItem.image" class="xiaohs-card-avatar" />
      <div v-else class="xiaohs-card-avatar avatar-placeholder">
        {{ getNameInitial(cardItem) }}
      </div>
    </div>

    <div class="xiaohs-card-info">
      <div class="xiaohs-card-name-row">
        <div class="xiaohs-card-name">{{ cardItem.name || "--" }}</div>
        <span class="card-type-badge">
          {{ cardItem.card_type_name || cardItem.sub_type_str || "小红书卡片" }}
        </span>
      </div>
      <div class="xiaohs-card-title">
        {{ cardItem.title || cardItem.sub_title || "暂无名片说明" }}
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs } from "vue";

export default {
  props: {
    cardItem: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const getNameInitial = (item) => {
      return (item?.name || item?.title || "卡").slice(0, 1);
    };

    return {
      ...toRefs(props),
      getNameInitial,
    };
  },
};
</script>

<style lang="scss" scoped>
.xiaohs-card-content {
  display: flex;
  position: relative;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
}

.card-category-badge {
  position: absolute;
  top: -10px;
  left: -10px;
  z-index: 1;
  padding: 2px 7px;
  border-radius: 14px 0 10px 0;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.4;
  background: linear-gradient(
    135deg,
    var(--card-tag-primary, #e6a23c),
    var(--card-tag-primary-light, #f3c36b)
  );
}

.avatar-wrap {
  flex-shrink: 0;
}

.xiaohs-card-avatar {
  display: block;
  width: 46px;
  height: 46px;
  border: 2px solid rgba(255, 255, 255, 0.9);
  border-radius: 14px;
  object-fit: cover;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #fb7185, #f43f5e);
}

.xiaohs-card-info {
  min-width: 0;
  flex: 1;
}

.xiaohs-card-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.xiaohs-card-name {
  min-width: 0;
  overflow: hidden;
  flex: 1;
  color: #18181b;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-type-badge {
  flex-shrink: 0;
  max-width: 72px;
  overflow: hidden;
  padding: 1px 6px;
  border: 1px solid var(--card-tag-border, rgba(230, 162, 60, 0.22));
  border-radius: 999px;
  color: var(--card-tag-text, #9a6a1f);
  font-size: 10px;
  font-weight: 700;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: var(--card-tag-bg, rgba(230, 162, 60, 0.14));
}

.xiaohs-card-title {
  overflow: hidden;
  margin-top: 2px;
  color: #71717a;
  font-size: 12px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
